import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useMcpResource } from '../resources'

export type McpConnection = {
  id: string
  clientName: string
  connectedBy: string
  connectedByYou: boolean
  brandScope: 'all' | 'narrowed'
  brandNames: string[]
  connectedAt: Date
  lastUsedAt: Date | null
  state: string
}

export const useMcpStore = defineStore('mcp', () => {
  const { getMcpConnections, delMcpConnection } = useMcpResource()

  const connections = ref<McpConnection[]>([])
  const serverUrl = ref('')
  const managesAll = ref(false)
  const loading = ref(false)
  const failed = ref(false)

  const load = async (organizationId: string) => {
    loading.value = true
    failed.value = false
    const { data } = await getMcpConnections(organizationId)
    loading.value = false

    if (!data) {
      failed.value = true
      return
    }

    serverUrl.value = data.serverUrl
    managesAll.value = data.managesAll
    connections.value = data.connections.map(connection => ({
      ...connection,
      connectedAt: new Date(connection.connectedAt),
      lastUsedAt: connection.lastUsedAt ? new Date(connection.lastUsedAt) : null
    }))
  }

  const revoke = async (organizationId: string, connectionId: string) => {
    const { data } = await delMcpConnection(organizationId, connectionId)
    if (!data) return false

    // The response already confirms it; refetching the list would only re-read one changed row.
    const revoked = connections.value.find(connection => connection.id === connectionId)
    if (revoked) revoked.state = 'revoked'
    return true
  }

  return { connections, serverUrl, managesAll, loading, failed, load, revoke }
})
